import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import jwtDecode from 'jwt-decode';
import { Observable } from 'rxjs';
import { ChangePasswordRQ } from 'src/main/webapp/assets/models/change.password';
import { JWTToken } from 'src/main/webapp/assets/models/jwt.token';
import { LoginRequest } from 'src/main/webapp/assets/models/login.request';
import { environment } from 'src/main/webapp/environments/environment';
import { LocalStorageService } from '../utils/localstorage.service';

const ONE_SECOND = 1000;

/**
 * Servizio per effettuare il login.
 */
@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(
    private readonly httpClient: HttpClient,
    private readonly localStorageService: LocalStorageService
  ) { }

  public login(loginRequest: LoginRequest): Observable<any> {
    return this.httpClient.post(environment.backend.login, loginRequest, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      observe: 'response',
      responseType: 'text'
    });
  }

  public isLoggedIn(): boolean {
    const token = this.localStorageService.retrieveItem(LocalStorageService.TOKEN_KEY) as string;

    return this.isValid(token);
  }

  public getUserRole(): string {
    const token = this.getStoredToken();

    if (this.isValid(token)) {
      const jwtToken: JWTToken = jwtDecode(token);

      return jwtToken.authorities[0];
    } else {
      return '';
    }
  }

  public logout(): void {
    this.localStorageService.removeItem(LocalStorageService.TOKEN_KEY);
  }

  public changePassword(changePasswordRQ: ChangePasswordRQ): Observable<any> {
    const token = `Bearer ${this.getStoredToken()}`;

    return this.httpClient.post(environment.backend.changepassword, changePasswordRQ, {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', Authorization: token }),
      observe: 'response',
      responseType: 'text'
    });
  }

  // utils
  private isValid(token: string): boolean {
    const tokenNotNull = token !== 'undefined' && token !== null && token.length > 0;
    try {
      const jwtToken: JWTToken = jwtDecode(token);

      return tokenNotNull && this.isNotExpired(jwtToken);
    } catch (error) {
      return false;
    }
  }

  public isNotExpired(jwtToken: JWTToken) {
    const now = new Date().getTime() / ONE_SECOND;

    return jwtToken.exp > now;
  }

  private getStoredToken(): string {
    return this.localStorageService.retrieveItem(LocalStorageService.TOKEN_KEY) as string;
  }

}
